import { LoyaltyProgressUtils as o } from "../LoyaltyProgress/utils.js";
var s;
((t) => {
  function a(e) {
    var r;
    return {
      status: e.subStatus,
      // Colors
      accentColor: e.stampCard.design.colors.accent,
      backgroundColor: e.stampCard.design.colors.generalBackground,
      cardColor: e.stampCard.design.colors.cardBackground,
      contentTextColor: e.stampCard.design.colors.text,
      progressBarColor: e.stampCard.design.colors.progressBorder,
      progressBackgroundColor: e.stampCard.design.colors.cardStripImage,
      // Font
      fontFamily: e.stampCard.design.fontFamily,
      // Texts
      customerName: ((r = e.user) == null ? void 0 : r.fullName) ?? "",
      currencyName: e.stampCard.design.texts.currencyAlias,
      tierName: e.stampCard.design.texts.customerAlias,
      cycleEndText: e.stampCard.design.texts.endCycleMessage,
      expiredText: e.stampCard.design.texts.endDateMessage,
      completeText: e.stampCard.design.texts.rewardMessage,
      footNote: e.stampCard.design.texts.slogan,
      terms: e.stampCard.design.texts.legalText,
      // Progress
      maxProgressValue: e.maxBalance,
      progressType: o.programmeTypeToProgress(e.stampCard.design.progressBarType),
      progressValue: e.balance,
      // Scan
      qrData: e.code,
      qrScanType: e.stampCard.design.identifierCodeType,
      // Expiration
      expirationDate: e.expirationDate,
      // Images
      progressBackgroundImage: e.stampCard.design.images.background,
      progressStampImage: e.stampCard.design.images.stamp
    };
  }
  t.stampPropsFromAccount = a;
})(s || (s = {}));
export {
  s as StampCardUtils
};
//# sourceMappingURL=utils.js.map
